import strings from '../../../Localization/Localization';

let content = {
  fieldKey: "content",
  type: "text",
  label: strings.form.notification.content.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "notificationSearch",
  fields: [
    content
  ]
}
